import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export interface PortalPublicData {
    html: string;
    css: string;
    isActive: boolean;
    companySlug: string;
    companyName: string;
}

@Injectable({ providedIn: 'root' })
export class PortalApiService {
    private http: HttpClient;
    private baseUrl: string;

    constructor(handler: HttpBackend) {
        // Bypassa interceptors — no Bearer token para API pública
        this.http = new HttpClient(handler);
        const apiUrl = environment.envVar.API_URL.endsWith('/')
            ? environment.envVar.API_URL.slice(0, -1)
            : environment.envVar.API_URL;
        this.baseUrl = `${apiUrl}/public/portal`;
    }

    getPortalByDomain(domain: string): Observable<PortalPublicData> {
        return this.http.get<PortalPublicData>(this.baseUrl, { params: { domain } });
    }

    getPortalBySlug(slug: string): Observable<PortalPublicData> {
        return this.http.get<PortalPublicData>(`${this.baseUrl}/${slug}`);
    }
}
